﻿var jquery = require("jquery");
require('polyfills');
import HabEvents from '../Global/habitaclia-events';

(function () {
    "use strict";

    var ListGallery = function (ListGalleryDTO) {
        this.__listGalleryDTO = ListGalleryDTO || { UserIsLogged: false };
        this.__userIsValid = __checkUser.call(this);
        this.__$nextBtns;
        this.__$prevBtns;
        this.imageWidth = 240;
        this.__nextButton = true;
        this.__$allGalleries = jquery('.js-slick-container');
        this.__urlGetImagenesInmueble = '/dotnet/Ficha/GetImagesInmueble';
        this.__urlImageDefault = '//static4.habimg.com/dotnet/content/img/default-image.jpg';
        this.__intersectionObserver;
        this.__intersectionObserverAvailable = false;
        if(window.IntersectionObserver !== undefined){
            this.__intersectionObserverAvailable = true;
        }
        __initListImages.call(this);
        __registerEvents.call(this);
        __registerQuieroContactenEvents.call(this);
    };

    var __checkUser = function () {
        return this.__listGalleryDTO.user && this.__listGalleryDTO.user.name && this.__listGalleryDTO.user.email && this.__listGalleryDTO.user.phone;
    };

    var __initListImages = function () {
        this.__$allGalleries = jquery('.js-slick-container');
        if(this.__intersectionObserverAvailable){
            this.__intersectionObserver = new window.IntersectionObserver((entries)=>{__handleIntersected.call(this, entries);});

            for(var i = 0; i < this.__$allGalleries.length; i++)
            {
                this.__intersectionObserver.observe(this.__$allGalleries[i]);
            }
        }else{
            for(var j = 0; j < this.__$allGalleries.length; j++)
            {
                __createDefaultDivs.call(this, this.__$allGalleries[j]);
            }
        }
    };

    var __handleIntersected = function(entries){
        for(var i = 0; i<entries.length; i++){
            if(entries[i].isIntersecting){
                const gallery = entries[i].target;
                __createDefaultDivs.call(this, gallery);
                this.__intersectionObserver.unobserve(gallery);
            }
        }
    };

    var __registerEvents = function () {
        jquery('.slick-arrow').click((e) => {
            const $list = jquery(e.currentTarget.parentElement);
            if (!$list.hasClass('swiped')) {
                __callListImages.call(this, $list);
            }
        });

        jquery('.slick-list').on('touchstart', (e) => {
            const $list = jquery(e.currentTarget.parentElement);
            if (!$list.hasClass('swiped')) {
                __callListImages.call(this, $list);
            }
        });
    };

    var __callListImages = function ($list) {
        $list.addClass('swiped');
        var self = this;
        var listData = $list.data();
        var urlGetJson = this.__urlGetImagenesInmueble + '?codigoEmpresa=' + listData.codem + '&codigoProducto=' + listData.codinm;
        jquery.ajax({
            type: "GET",
            url: urlGetJson,
            dataType: "json",
            success: function (response) {
                if (!!response.data && response.data.length > 0) {
                    __setImages.call(self, $list, response.data);
                }
            },
            error: function(){}
        });
    };
    var __createDefaultDivs = function (list) {
        var self = this;
        var $list = jquery(list);
        var listData = $list.data();
        const firstImage = $($list[0]).find('img')[0];
        if(firstImage){
            firstImage.src = $list[0].children[0].dataset.image;
        }
        for (var i = 1; i < listData.countimg; i++) {
            var newItem = '<div class="slick-bg" data-image="' + this.__urlImageDefault + '" style="background-image: url(' + this.__urlImageDefault + ')"><div class="image"><img/></div></div>';
            $list.append(newItem);
        }
        if(this.__listGalleryDTO.Translate && !$list.hasClass('js-slick-container-agg')){
            var contactItem = '<div class="slick-bg slick-bg-black" data-image="' + this.__urlImageDefault + '"><div class="image"><img/></div><div class="slick-contact-container"><div class="slick-contact-wrap"><span id="js-slick-contact-title'+listData.codanuncio+'" class="slick-contact-title">'+this.__listGalleryDTO.Translate.likeIt+'</span><button id="js-slick-contact'+listData.codanuncio+'" type="button" class="button js-slick-contact js-no-click-item">' + this.__listGalleryDTO.Translate.contactMe + '</button></div></div></div>';
            $list.append(contactItem);
        }
        var $fotoLista = $list.siblings('.foto-listado');
        if($fotoLista.length>0){
            var $counter = jquery($fotoLista.find('.js-slick-counter'));
            var totalCount = parseInt($counter.text()) + 1;
            $counter.text(totalCount);
        }

        __bindSlick.call(self, $list);
        __registerSlickEvents.call(self, $list);
        __setCurrentImageNumber.call(self, $list);
    };

    var __setImages = function ($list, data) {
        const images = $list.find('img');
        const imageContainer = $list.find('.slick-bg');
        let numImages = images.length -1;
        imageContainer[numImages-1].setAttribute('data-image', data[0].UrlImagen);
        images[numImages].setAttribute('src', data[0].UrlImagen);
        for (var i = 1; i < numImages; i++) {
            imageContainer[i-1].setAttribute('data-image', data[i].UrlImagen);
            images[i].setAttribute('src', data[i].UrlImagen);
            images[i].setAttribute('alt', '');
        }
    };

    var __bindSlick = function ($list) {
        $list.slick({
            infinite: false,
            speed: 100,
            lazyLoad:'ondemand',
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true
        });
    };

    var __setCurrentImageNumber = function ($list) {
        var $fotoLista = $list.siblings('.foto-listado');
        if ($fotoLista.length > 0) {
            var $active = jquery($list.find('.slick-current'));
            var $number = $active.attr('data-slick-index');
            var activeImage = parseInt($number) + 1;
            var $current = jquery($fotoLista.find('.js-slick-current'));
            $current.text(activeImage);
        }
    };

    var __registerSlickEvents = function ($list) {
        var $next = jquery($list.find('.slick-next'));
        var $prev = jquery($list.find('.slick-prev'));

        var $contact = jquery($list.find('.js-slick-contact'));

        jquery($list.find('.slick-list')).on('touchstart', (e) => {
            const $list = jquery(e.currentTarget.parentElement);
            if (!$list.hasClass('swiped')) {
                __callListImages.call(this, $list);
                $list.on('afterChange', function () {
                    __setCurrentImageNumber.call(this, $list);
                });
            }
        });
        $next.on('click touchstart', (e) => {
            const $list = jquery(e.currentTarget.parentElement);
            if (!$list.hasClass('swiped')) {
                __callListImages.call(this, $list);
            }
            jquery.publish(HabEvents.EventsEnum.ClickListGallery, ['click', 'next']);
        });

        $prev.on('click touchstart', () => {
            jquery.publish(HabEvents.EventsEnum.ClickListGallery, ['click', 'previous']);
        });

        if(this.__listGalleryDTO.Translate){
            $contact.click((e) => {
                e.preventDefault();
                e.stopPropagation();
                jquery.publish(HabEvents.EventsEnum.ClickQuieroContactenSlickBtn);
                var codigoAnuncio = jquery(e.currentTarget).attr('id').replace('js-slick-contact', '');
                if(this.__listGalleryDTO.UserIsLogged && this.__userIsValid){
                     __checkCaptcha.call(this,codigoAnuncio);
                }else{
                    __clickDetail.call(this, codigoAnuncio);
                }
            });
        }
    };

    var __registerQuieroContactenEvents = function() {
        var $nodelist = document.querySelectorAll('.js-list-quiero-contacten');
        var $list = Array.prototype.slice.call($nodelist);
        document.querySelector('.listado-qqmc-menu') && jquery('.contenedorinfo').addClass('padding-qqmc');
        $list.forEach(ficha => {
            ficha.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                jquery.publish(HabEvents.EventsEnum.ClickQuieroContactenListado);
                var codigoAnuncio = ficha.nextElementSibling.getAttribute('id');
                if(this.__listGalleryDTO.UserIsLogged && this.__userIsValid){
                    __checkCaptcha.call(this,codigoAnuncio);
                }else{
                    __clickDetail.call(this, codigoAnuncio);
                }
            });
        });
    };

    var __checkCaptcha = function (codigoAnuncio) {
        var self = this;

        try
        {
            var captchaValuesDTO = {CodigoAnuncio: codigoAnuncio};
            jquery.ajax({
                type: "POST",
                url: self.__listGalleryDTO.UrlAjaxValidarCaptcha,
                data: captchaValuesDTO,
                success:function(data){
                    __ajaxSolicitudToAsp.call(self, codigoAnuncio, data.starskyyhash);
                },
                error: function () {
                    __clickDetail.call(self, codigoAnuncio);
                }
            });
        }
        catch (error) {
            __clickDetail.call(self, codigoAnuncio);
        }
    };

    var __ajaxSolicitudToAsp = function (codigoAnuncio,captchaIsValid) {
        var self = this;
        var descripcion_net = this.__listGalleryDTO.Translate.descriptionMessage;
        var nombre_net = this.__listGalleryDTO.user.name;
        var telefono_usuario =  this.__listGalleryDTO.user.phone;
        var email = this.__listGalleryDTO.user.email;
        var isSimilar = false;
        var isPromocion = false;
        var starskyyhash = captchaIsValid;
        var alertaOrigen = 4;
        var solData = { nombre_net, telefono_usuario, email, descripcion_net, isSimilar, starskyyhash, alertaOrigen};
        var urlSolicitud = this.__listGalleryDTO.UrlAjaxContactarAsp.replace('{0}', codigoAnuncio).replace('{1}', isPromocion);
        var reqAsp = jquery.ajax({
            type: "POST",
			url: urlSolicitud,
            data: solData,
            dataType: "text"
        });

		reqAsp.done(function (data) {

			/* Àlex. TODO: No gestionamos ningún tipo de respuesta de error (spam, blacklist, empty response...) */

            var $data = jquery(data);
            var $telefonoContacto = $data.find('.contactotelf');
            var $btnClicked = jquery('#js-slick-contact'+codigoAnuncio);
            var $btnQqmc = jquery('#button-qqmc-'+codigoAnuncio);

            var feedbackContacted ='';
            if ($telefonoContacto.length > 0) {
                var $telephoneText = $telefonoContacto.find('telefono_contacto');
                if ($telephoneText) {
                    var rawTelephone = $telephoneText[0].innerText;
                    var regex = /(\d{1,20})/gm;
                    var telephones = regex.exec(rawTelephone);
                    var $telephoneAnchors = jquery($telefonoContacto[0]).find('a');
                    if ($telephoneAnchors && $telephoneAnchors.length > 0) {
                        Array.from($telephoneAnchors).forEach(telephone => telephone.href = 'tel:' + telephones[0]);
                    }
                }
                var telefono = $telefonoContacto.html();
                feedbackContacted = '<span class="slick-contact-msg">'+self.__listGalleryDTO.Translate.contactedMessage+'</span>';
                jquery('#js-slick-contact-title'+codigoAnuncio).remove();
                $btnClicked.after(telefono);
                if($btnQqmc) {
                    var feedbackQuieroContacten = '<div class="button-qqmc-feedback">'+telefono+'</div>';
                    jquery('#button-qqmc-'+codigoAnuncio).remove();
                    jquery('#'+codigoAnuncio).before(feedbackQuieroContacten);
                }
                __sendSegmentLeadData.call(self, codigoAnuncio);
            }else{
                feedbackContacted = '<span class="slick-contact-msg">'+self.__listGalleryDTO.Translate.errorContact+'</span>';
                __clickDetail.call(self, codigoAnuncio);
            }
            var $telLlamar = $btnClicked.siblings('.tel-llamar');
            if($telLlamar.length>0){
                $telLlamar.before(feedbackContacted);
                jquery($btnClicked.siblings('.ico-llamar')).html('<img src="'+self.__listGalleryDTO.IconTelf+'"/>');
            }else{
                $btnClicked.before(feedbackContacted);
            }
            jquery($btnClicked.parents('.slick-contact-container')).addClass('bg-orange-alpha-06');
            $btnClicked.remove();
		});

        reqAsp.fail(function () {
            var $btnClicked = jquery('#js-slick-contact'+codigoAnuncio);
            var feedbackContacted = '<span class="slick-contact-msg">'+self.__listGalleryDTO.Translate.errorContact+'</span>';
            $btnClicked.before(feedbackContacted);
			$btnClicked.remove();
			__clickDetail.call(self, codigoAnuncio);
        });
    };

    var __sendSegmentLeadData = function (codigoAnuncio) {
        var item = document.getElementById('id' + codigoAnuncio);
        jquery.publish(HabEvents.EventsEnum.SegmentTrackLead, { isDetail: false, codigoAnuncio, dataSet: item.dataset });
    };

    var __clickDetail = function(codigoAnuncio){
        var detailUrl = jquery('#id'+codigoAnuncio).attr('data-href');
        var mDetailUrl = jquery('#id'+codigoAnuncio).attr('data-gtmurl');
        if(detailUrl){
            document.location.href = detailUrl + '#js-contact';
        }else if(mDetailUrl){
            document.location.href = mDetailUrl + '#js-contact';
        }
    };

	ListGallery.prototype = {
	    constructor: ListGallery
    };

	if (typeof module !== 'undefined' && module.exports) {
	    module.exports = ListGallery;
	}
	else {
	    window.ListGallery = ListGallery;
	}

}());